import { formatCurrency } from "@/lib/pricing-utils";
import type { PricingBreakdown as PricingData } from "@/lib/pricing-utils";

interface PricingBreakdownProps {
  pricing: PricingData;
}

export function PricingBreakdown({ pricing }: PricingBreakdownProps) {
  return (
    <div className="space-y-3" data-testid="pricing-breakdown">
      {pricing.breakdown.map((item, index) => (
        <div key={index} className="flex justify-between text-luxury-sm font-serif font-normal tracking-luxury-tight">
          <span className="text-muted-foreground" data-testid={`breakdown-label-${index}`}>
            {item.label}
          </span>
          <span className={`${item.amount.startsWith('-') ? 'text-palm font-medium' : ''}`} data-testid={`breakdown-amount-${index}`}>
            {formatCurrency(item.amount)}
          </span>
        </div>
      ))}
      
      <div className="flex justify-between font-serif font-normal text-luxury-base pt-3 border-t border-border">
        <span data-testid="total-label">Stay total (USD)</span>
        <span data-testid="total-amount">{formatCurrency(pricing.total)}</span>
      </div>

      <p className="text-xs text-muted-foreground">Includes the taxes and fees listed above.</p>

      {pricing.securityDeposit && parseFloat(pricing.securityDeposit) > 0 && (
        <div className="flex justify-between font-serif font-normal text-luxury-sm pt-3 border-t border-border mt-1">
          <div>
            <span className="text-muted-foreground">Refundable security deposit</span>
            <p className="text-luxury-xs text-muted-foreground/70 mt-0.5">Charged separately. Returned after checkout.</p>
          </div>
          <span className="text-muted-foreground">{formatCurrency(pricing.securityDeposit)}</span>
        </div>
      )}

      {pricing.coupon && pricing.appliedDiscount === 'coupon' && (
        <div className="text-luxury-xs font-serif font-medium text-palm mt-2">
          Coupon "{pricing.coupon.code}" applied
        </div>
      )}
      {pricing.coupon && pricing.appliedDiscount === 'long_stay' && (
        <div className="text-luxury-xs font-serif font-medium text-palm mt-2">
          A larger {pricing.nights >= 30 ? 'monthly' : 'weekly'} discount was applied instead of coupon "{pricing.coupon.code}"
        </div>
      )}
    </div>
  );
}
